import { Box, Button, Stack, Typography } from "@mui/material";
import React, { useState } from "react";
import Chip from "@mui/material/Chip";
// import AutoScrollingChips from "./AutoScrollingChips";
import { FaRegCompass } from "react-icons/fa";
import { FaArrowRight } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import AutoScrollingChips from "./AutoScrollingChips";

const BottomSection1 = () => {
  const navigate = useNavigate();
  const [values, setValues] = useState(":");
  const handleClick = () => {
    navigate("/industries-details");
  };
  return (
    <Stack
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        // border: "1px solid red",
        marginBottom: { lg: "64px", md: "40px", sm: "36px", xs: "40px" },

        marginTop: { xl: "40px", lg: "40px", md: "32px", sm: "32px" },
      }}
    >
      <Stack
        sx={{
          width: { xl: "70%", lg: "79%", md: "91%", sm: "88%", xs: "100%" },
          height: { xl: "60px", lg: "60px", sm: "60px" },
          backgroundColor: "white",
          // borderRadius: "8px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          // marginTop: { xl: "20px", lg: "12px" },
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
          // border: "1px solid red",
        }}
      >
        <Stack
          sx={{
            width: { xl: "8px", lg: "8px", xs: "4px" },
            height: { xl: "60%", lg: "100%", xs: "100%" },
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            // border: "2px solid red",
            // backgroundColor: "rgb(5 78 146)",
            backgroundColor: "rgb(5 78 146)",
            borderTopRightRadius: "8px", // Adjust the value as needed
            borderBottomRightRadius: "8px", // Adjust the value as needed
          }}
        >
          <h4 style={{ color: "rgb(5 78 146)" }}>{""}</h4>
        </Stack>

        <Stack
          sx={{
            // marginLeft: { xl: "28px", lg: "28px", xs: "8px" },
            // width: { xl: "8%", lg: "14%", xs: "20%" },
            height: { xl: "70%", lg: "100%" },
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <FaRegCompass />{" "}
          <Typography
            sx={{
              fontFamily:
                "'_Inter_148820', '_Inter_Fallback_148820', sans-serif",
              marginLeft: { xl: "12px", lg: "12px", xs: "4px" },
            }}
          >
            Sectors
          </Typography>
        </Stack>

        <Stack
          sx={{
            // border: "1px solid green",
            marginLeft: { xl: "20px", lg: "20px", xs: "8px" },
            marginRight: { xl: "20px", lg: "20px", xs: "0px" },
            height: { xl: "70%", lg: "90%", xs: "80%" },
            width: { xl: "86%", lg: "84%", md: "88%", sm: "88%", xs: "60%" },
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            overflow: "hidden", // Ensures children don't overflow outside
            position: "relative", // Defines a boundary for children
          }}
        >
          <AutoScrollingChips />
        </Stack>

        {/* <Stack
          sx={{
            // border: "1px solid blue",
            marginRight: { xl: "0px", lg: "0px", xs: "0px" },
            marginLeft: { xl: "0px", lg: "0px", xs: "8px" },
            width: { xl: "12%", lg: "15%", md: "12%", sm: "18%", xs: "25%" },
            height: { xl: "60%", lg: "90%", md: "70%", xs: "80%" },
            fontSize: { xs: "8px" },
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily:
                "'_Inter_148820', '_Inter_Fallback_148820', sans-serif",
              marginLeft: { xl: "12px", lg: "12px", xs: "0px" },
            }}
          >
            <Button
              variant="outlined"
              size="medium"
              sx={{
                borderColor: "rgb(5, 78, 146)",
                color: "rgb(5, 78, 146)",
                textTransform: "none",
                "&:hover": {
                  backgroundColor: "rgb(31, 133, 192)",
                  color: "white",
                  borderColor: "rgb(31, 133, 192)",
                },
                borderRadius: "8px",
              }}
              onClick={handleClick}
              
            >
              View all{" "}
            </Button>
          </Typography>
        </Stack> */}
      </Stack>
    </Stack>
  );
};

export default BottomSection1;